import React from 'react';
import LoanHighlights from '../Components/LoanHighlights'; 
const Service = () => {
  return (
    <div>
      <LoanHighlights />
    </div>
  );
};

export default Service;


